import { MoveHorizontal, MoveVertical } from "lucide-react";
import { formatCm } from "@/lib/text-metrics";

interface DimensionCardsProps {
  widthCm: number;
  heightCm: number;
}

// Shown below the preview regardless of 2D/3D mode, so the physical size
// is always visible - not just when the (smaller) in-preview ruler badge
// happens to fit.
export function DimensionCards({ widthCm, heightCm }: DimensionCardsProps) {
  return (
    <div className="grid grid-cols-2 gap-3">
      <div className="flex items-center gap-2 rounded-lg border bg-card px-3 py-2">
        <MoveHorizontal className="size-4 text-muted-foreground" />
        <div className="leading-tight">
          <p className="text-[11px] text-muted-foreground">Breite</p>
          <p className="text-sm font-semibold tabular-nums">
            {formatCm(widthCm)}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 rounded-lg border bg-card px-3 py-2">
        <MoveVertical className="size-4 text-muted-foreground" />
        <div className="leading-tight">
          <p className="text-[11px] text-muted-foreground">Höhe</p>
          <p className="text-sm font-semibold tabular-nums">
            {formatCm(heightCm)}
          </p>
        </div>
      </div>
    </div>
  );
}
